import React from "react";

/**
 * This component is used to render the body of the appointment delete dialog box.
 * It shows a confirmation message along with an input to leave reason to delete.
 * @param {Object} props 
 * @param {Function} handleInputChange it is used to set note value
 */
const AppointmentDeleteDialogBox = ({ handleAppointmentDeleteInputChange }) => {
  return (
    <>
      <p className="mb-0"> Are you sure you want to delete? </p>
      <div id="delete-form-group" className="form-group">
        <hr className="light" />
        <label htmlFor="delete-input" className="control-label">
          Reason for Cancel
        </label>
        <textarea
          id="delete-input"
          type="text"
          name="note"
          className="form-control"
          rows={3}
          onChange={event => handleAppointmentDeleteInputChange({ note: event.currentTarget.value })}
        />
        <div className="form-check mt-3">
          <input
            type="checkbox"
            id="send-email-checkbox"
            className="form-check-input"
            defaultChecked={true}
            onChange={event => handleAppointmentDeleteInputChange({ isSendEmailChecked: event.currentTarget.checked })}
          />
          <label htmlFor="send-email-checkbox" className="form-check-label">
            Send Email
          </label>
        </div>
      </div>
    </>
  );
};

export default AppointmentDeleteDialogBox;
